var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "map-control-switch leaflet-bottom",
      staticStyle: {
        "margin-bottom": "50px",
        width: "160px",
        height: "36px",
        "line-height": "36px",
        padding: "10px 0 0 12px",
        color: "#333333",
        "font-size": "12px"
      }
    },
    [
      _c(
        "el-radio",
        {
          attrs: { label: _vm.address },
          nativeOn: {
            click: function($event) {
              $event.preventDefault()
              return _vm.change.apply(null, arguments)
            }
          },
          model: {
            value: _vm.dgValue,
            callback: function($$v) {
              _vm.dgValue = $$v
            },
            expression: "dgValue"
          }
        },
        [_vm._v(_vm._s(_vm.title))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }